export const countryCodes =
  process.env.NEXT_PUBLIC_NODE_ENV !== "production"
    ? ([
        { code: "+966", country: "Saudi Arabia", flag: "🇸🇦" },
        { code: "+971", country: "UAE", flag: "🇦🇪" },
        // { code: "+965", country: "Kuwait", flag: "🇰🇼" },
        // { code: "+973", country: "Bahrain", flag: "🇧🇭" },
        // { code: "+974", country: "Qatar", flag: "🇶🇦" },
        // { code: "+968", country: "Oman", flag: "🇴🇲" },
        // { code: "+20", country: "Egypt", flag: "🇪🇬" },
        { code: "+91", country: "India", flag: "🇮🇳" },
        { code: "+92", country: "Pakistan", flag: "🇵🇰" },
        // { code: "+962", country: "Jordan", flag: "🇯🇴" },
        // { code: "+961", country: "Lebanon", flag: "🇱🇧" },
        // { code: "+963", country: "Syria", flag: "🇸🇾" },
        // { code: "+964", country: "Iraq", flag: "🇮🇶" },
        // { code: "+98", country: "Iran", flag: "🇮🇷" },
        // { code: "+972", country: "Israel", flag: "🇮🇱" },
        // { code: "+967", country: "Yemen", flag: "🇾🇪" },
        // { code: "+249", country: "Sudan", flag: "🇸🇩" },
      ] as const)
    : ([{ code: "+966", country: "Saudi Arabia", flag: "🇸🇦" }] as const);
